export default __webpack_public_path__ + "static/media/MyResumeEsp.d266f112.pdf";